import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export function Progress({ min = 0, max = 100, value, setValue, step, startText, endText }) {
  const progressBarRef = useRef(null);

  const [progress, setProgress] = useState(0);

  const roundValue = (percent, step) => {
    const roundedValue = Math.round(percent / step) * step;
    return roundedValue;
  };

  const handleProgressChange = (progress) => {
    let value = (progress / 100) * (max - min) + min;

    if (step) {
      value = roundValue(value, step);
    }

    setValue(value);
  };

  const updateProgress = (clientX) => {
    const rect = progressBarRef.current.getBoundingClientRect();
    const clickPosition = clientX - rect.left;
    let newProgress = (clickPosition / rect.width) * 100;
    if (newProgress <= 0) {
      newProgress = 0;
    } else if (newProgress >= 100) {
      newProgress = 100;
    }
    setProgress(newProgress);
    handleProgressChange(newProgress);
  };

  const handleTouchMove = (event) => {
    updateProgress(event.touches[0].clientX);
  };

  const handleTouchEnd = (event) => {
    updateProgress(event.changedTouches[0].clientX);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
  };

  const handleTouchStart = () => {
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  };

  useEffect(() => {
    setProgress((value / (max - min)) * 100);
  }, [value]);

  return (
    <>
      <ProgressWrap>
        <ProgressBox onTouchStart={handleTouchStart}>
          <ProgressBar ref={progressBarRef}>
            <ProgressFill style={{ width: `${progress}%` }} />
            <ProgressThumb style={{ left: `${progress}%` }} />
          </ProgressBar>
        </ProgressBox>
        <ProgressLabels>
          <span>{startText}</span>
          <span>{endText}</span>
        </ProgressLabels>
      </ProgressWrap>
    </>
  );
}

const ProgressWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
`;

const ProgressBox = styled.div`
  width: 100%;
  padding: 16px 11px;
  position: relative;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.colors.gray300};
  border-radius: 2px;
  cursor: pointer;
  position: relative;
`;

const ProgressFill = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 2px;
  transition: width 150ms;
`;

const ProgressThumb = styled.div`
  width: 14px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: left 150ms;
`;

const ProgressLabels = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
  font-size: 12px;
  padding: 0 8px;
`;
